import AlertProvider from './context/AlertContext';
import UserProvider from './context/UserContext';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './css/index.css';
import App from './App';
import BlogProvider from './context/BlogContext';
import SEO_METATAGS from './components/SEO/Metatags';
import YCSTM from './YCSTM';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
	<AlertProvider>
		<YCSTM />
		<SEO_METATAGS />

		<UserProvider>
			<BlogProvider>
				<App />
			</BlogProvider>
		</UserProvider>
	</AlertProvider>,
);
